import { get } from 'lodash';
import { ERegions } from '../../../../../../shared/constants';
import template from './jk-message.jade';

const regionNames = (get(window, 'addFormState.regions') || []).reduce((acc, { type, id, name }) => {
  if (type === 'region') {
    acc[id] = name;
  }

  return acc;
}, {});

const regions = {
    ...regionNames,
    [ERegions.moscow]: 'Москва и область',
    [ERegions.moscowRegion]: 'Москва и область',
    [ERegions.spb]: 'Санкт-Петербург и область',
    [ERegions.spbRegion]: 'Санкт-Петербург и область',
};

export default angular
    .module('cian.addForm.jkMessage', [])
    .directive('cianAfAddressJkMessage', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['jkService',  function (jkService) {
            this.jkService = jkService;
            this.getRegionName = () => regions[jkService.isJkRegion()];
        }],
        controllerAs: 'jkMessage',
        template,
        replace: true,
    }))
    .name;
